import * as Yup from 'yup';
import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from 'libphonenumber-js';

export const parseTelephoneToE164 = (value, defaultCountry = 'GB') => {
  if (!value) {
    return '';
  }

  try {
    const parsedPhoneNumber = value.startsWith('+')
      ? parsePhoneNumberFromString(value)
      : parsePhoneNumberFromString(value, defaultCountry);

    return parsedPhoneNumber ? parsedPhoneNumber.number : value;
  } catch (error) {
    return value;
  }
};

export const normalizeTelephoneValue = (value, defaultCountry = 'GB') => {
  return parseTelephoneToE164(value, defaultCountry);
};

export const isValidGbTelephone = (value) => {
  if (!value) {
    return true;
  }

  const normalizedValue = parseTelephoneToE164(value, 'GB');

  if (!normalizedValue) {
    return true;
  }

  try {
    return isValidPhoneNumber(normalizedValue);
  } catch (error) {
    return false;
  }
};

export const telephoneValidationSchema = (
  message = 'Phone number is not valid',
) =>
  Yup.string().test({
    name: 'telephone',
    message,
    test: (value) => isValidGbTelephone(value),
  });
